// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2WHmO","options":"AnswerScale_options__1Dg5P","selected":"AnswerScale_selected__3ddEP"};